export const SET_STATE_LOCK_PM = "SET_STATE_LOCK_PM";
export const SET_ENABLE_PM = "SET_ENABLE_PM";
export const SET_SOCKET_PM = "SET_SOCKET_PM";
export const SET_SOCKET_CONNECT_PM = "SET_SOCKET_CONNECT_PM";
export const SET_ROOMS_PM = "SET_ROOMS_PM";
export const SET_IN_ROOM_PM = "SET_IN_ROOM_PM";
export const SET_NAME_IN_ROOM_PM = "SET_NAME_IN_ROOM_PM";
export const SET_PLAYERS_IN_ROOM_PM = "SET_PLAYERS_IN_ROOM_PM";
export const SET_WATCHER_PM = "SET_WATCHER_PM";
export const SET_OUTSIDER_PM = "SET_OUTSIDER_PM";
export const SET_TRACKER_PM = "SET_TRACKER_PM";
export const SET_VISIBLE_CHAT_PM = "SET_VISIBLE_CHAT_PM";
export const TOGGLE_VISIBLE_CHAT_PM = "TOGGLE_VISIBLE_CHAT_PM";
export const SET_MESSAGES_PM = "SET_MESSAGES_PM";
export const ADD_MESSAGE_PM = "ADD_MESSAGE_PM";
export const SET_STATE_SERVER_PM = "SET_STATE_SERVER_PM";
export const SET_REQUEST_PM = "SET_REQUEST_PM";
export const EMIT_SHARED_PLAYLIST_PM = "EMIT_SHARED_PLAYLIST_PM";
export const EMIT_SUGGESTED_PLAYLIST_PM = "EMIT_SUGGESTED_PLAYLIST_PM";
export const SET_PERMISSION_STATE_PLAYER_PM = "SET_PERMISSION_STATE_PLAYER_PM";
export const BROADCAST_PLAYER_MESSAGE_PM = "BROADCAST_PLAYER_MESSAGE_PM";
export const BROADCAST_AUDIO_PM = "BROADCAST_AUDIO_PM";
export const SET_AUDIO_INFOS_PM = "SET_AUDIO_INFOS_PM";
export const SET_DEV_PM = "SET_DEV_PM";
export const BROADCAST_CURSOR_FROM_ACTION_PM = "BROADCAST_CURSOR_FROM_ACTION_PM";
export const SET_QUEUES_DJ_PM = "SET_QUEUES_DJ_PM";
export const SET_RESPONSE_TO_DJ_PM = "SET_RESPONSE_TO_DJ_PM";
export const SET_SHOW_AUDIO = "SET_SHOW_AUDIO";
export const REFRESH_PUBLIC_SESSIONS = "REFRESH_PUBLIC_SESSIONS";
